import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  className = '',
  children,
  confirmDisabled = false,
}) => {
  const dialogRef = useRef(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialogRef.current?.querySelector('.btn-neutral')?.focus();
    const trap = (event) => {
      if (event.key !== 'Tab') return;
      const buttons = [...(dialogRef.current?.querySelectorAll('button:not(:disabled),input:not(:disabled),textarea:not(:disabled),select:not(:disabled),a[href]') || [])];
      if (!buttons.length) return;
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', trap);
    return () => { document.body.style.overflow = overflow; document.removeEventListener('keydown', trap); previous?.focus?.(); };
  }, [open]);
  useEffect(() => {
    if (!open || typeof document === 'undefined') {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onCancel]);

  if (!open || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div ref={dialogRef} className={`confirm-dialog ${className}`} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <div className="confirm-dialog-header">
          <h4 id="confirm-dialog-title">{title}</h4>
          <button type="button" className="confirm-dialog-close" onClick={onCancel} aria-label={cancelText}>
            ×
          </button>
        </div>

        <p className="confirm-dialog-message">{message}</p>
        {children}

        <div className="confirm-dialog-actions">
          <button type="button" className="btn btn-neutral" onClick={onCancel}>
            {cancelText}
          </button>
          <button type="button" className="btn btn-danger" disabled={confirmDisabled} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
